const apiKey = process.env.GATSBY_IP_API_KEY

export async function getCountryCode(): Promise<String> {
  const requestOptions = {
    method: "GET",
  }
  const response = await fetch(
    `https://api.ipdata.co?api-key=${apiKey}`,
    requestOptions
  )

  if (!response.ok) {
    throw Error()
  }

  const ipData = await response.json()
  // eslint-disable-next-line camelcase
  return ipData.country_code
}
